import Bowser from "bowser";
import { createRoot } from "react-dom/client";
let parser;
let browserResult;
function assertIsBrowser(label) {
  if (
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    typeof window !== "undefined" && // eslint-disable-next-line unicorn/no-typeof-undefined
    typeof window.navigator !== "undefined" && typeof window.navigator.userAgent === "string"
  )
    return;
  throw new Error(`[tsx:${label ?? "assertIsBrowser"}] Not in a browser environment.`);
}
async function injectScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.addEventListener("load", () => resolve());
    script.addEventListener("error", (err) => reject(err));
    script.src = src;
    document.head.append(script);
  });
}
function render(selector, element) {
  assertIsBrowser("render");
  const container = document.querySelector(selector);
  if (!container)
    throw new Error(`[tsx:render] Element matching selector "${selector}" could not be found.`);
  const root = createRoot(container);
  root.render(element);
  return root.unmount.bind(root);
}
function getPlatformDetails() {
  assertIsBrowser("getBrowser");
  if (!parser) {
    parser = Bowser.getParser(window.navigator.userAgent);
  }
  if (!browserResult) {
    browserResult = parser.getResult();
  }
  return browserResult;
}
function isMobile() {
  assertIsBrowser("isMobile");
  const details = getPlatformDetails();
  if (!details.platform.type)
    return false;
  return ["tablet", "mobile"].includes(details.platform.type);
}
function isStandalone() {
  assertIsBrowser("isStandalone");
  return Boolean(Reflect.get(navigator, "standalone"));
}
export {
  assertIsBrowser,
  getPlatformDetails,
  injectScript,
  isMobile,
  isStandalone,
  render
};
//# sourceMappingURL=runtime.js.map
